<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">分类管理</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="分类名称">
          <el-input v-model="query.name" placeholder="分类名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                     @click="submitQuery(1)">查询
          </el-button>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-circle-plus-outline"
                     @click="$common.goRouterLink({ name: 'shopTypeDetail'})">添加
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>店铺分类列表</span>
    </div>
    <el-table highlight-current-row :data="shopTypes" border>
      <el-table-column align="center" label="序号" type="index"/>
      <el-table-column align="center" label="分类图片">
        <template slot-scope="scope">
          <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
            <div slot="error" class="image-slot">
              <el-image title="加载失败"
                        src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分类名称" prop="name"/>
      <el-table-column align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini"
                     @click="$common.goRouterLink({ name: 'shopTypeDetail', query: { shopTypeId: scope.row.id }})">
            详情
          </el-button>
          <el-button type="danger" size="mini"
                     @click="del(scope.row.id)">
            删除
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <vue-pager :datafile="fillData" url="/shopType/pageShopType" :query="query" ref="pager"
               :init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      shopTypes: [],
      dynamicPath:config.dynamicResourcePath,
    }
  },
  created() {
    
  },
  methods: {
    fillData(_response) {
      this.shopTypes = _response.items || [];
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    del(_id) {
      var _this = this;
      _this
          .$confirm("是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.$common.ajaxRequest({
              url: '/shopType/deleteShopType',
              data: {
                shopTypeId: _id
              },
              success(response) {
                _this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                  onClose: function () {
                    _this.submitQuery(1);
                  }
                });
              }
            });
          })
    },
  },
}
</script>